module.exports = __webpack_public_path__ + "img/background3.67a1112b.jpg";